import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  IconButton,
  // Autocomplete,
  Card
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import * as yup from 'yup';
import { experimentalStyled as styled } from '@mui/material/styles';
// import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { updateUser, getUserDetails } from '../../service/user.service';
import BackArrowIcon from '../../svg/BackArrowIcon';
import { getCke } from '../../helper/cookieHelper';
import { UPDATE_ORG, UPDATE_USER } from '../../redux/constants';
// import { FilterArrayByKey } from '../../helper/commonHelper';
import BackgroundImage from '../../svg/FainlearnBackSvg.svg';
import Page from '../Page';
import { USER_AVATAR } from '../../utils/constants';
import CollegeSelectionBox from '../common/CollegeSelectionBox';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const useStyles = makeStyles({
  wrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  button: {
    width: '100%',
    fontSize: '16px',
    padding: '10px 0',
    borderRadius: '100px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  }
});

export default function StudentForm({ handleBack }) {
  const classes = useStyles();
  const currentUser = useSelector((state) => state.auth.currentUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fullName, setFullName] = useState(currentUser?.fullName ?? '');
  const [gender, setGender] = useState('male');
  const [displayAdditionalInfo, setIsAdditionalInfo] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  // Selected college
  const [selectedCollege, setSelectedCollege] = useState(null);
  // College error
  const [collegeErr, setCollegeErr] = useState('');

  const [fullNameError, setFullNameError] = useState('');

  const handleNext = async () => {
    let isAllFieldValid = true;
    await yup
      .string()
      .required()
      .isValid(fullName)
      .then((isValid) => {
        if (!isValid) {
          isAllFieldValid = false;
          setFullNameError(true);
        }
      });

    if (selectedCollege === null) {
      isAllFieldValid = false;
      setCollegeErr({ message: 'Please select college/school' });
    } else if (selectedCollege?.type && selectedCollege?.name.toLowerCase() === '') {
      isAllFieldValid = false;
      setCollegeErr(true);
    } else {
      setCollegeErr('');
    }

    if (isAllFieldValid) {
      updateUserAndRoute();
    }
  };

  const updateUserAndRoute = async () => {
    setBtnLoading(true);
    const userObj = {
      fullName: fullName.trim(),
      gender,
      profile: 'student',
      profileImage: USER_AVATAR.filter((avatar) => avatar.includes(`_${gender}`))[
        Math.floor(Math.random() * 3)
      ]
    };
    // Other school/college is selected
    if (selectedCollege?.view === 'custom') {
      userObj.collegeName = `Other, ${selectedCollege.name}`;
    } else {
      userObj.collegeName = selectedCollege.name.trim();
      userObj.collegeId = selectedCollege.id;
    }
    userObj.educationType = selectedCollege.type;
    const userId = getCke('userId');
    const res = await updateUser(userId, userObj);
    if (res) {
      await updateUser(userId, {
        fullName: fullName.trim(),
        isOnboarding: false
      });
      const getUserRes = await getUserDetails(userId);
      if (getUserRes) {
        dispatch({ type: UPDATE_USER, payload: getUserRes.user });
        dispatch({ type: UPDATE_ORG, payload: getUserRes.orgList });
        navigate('/', { replace: true });
      }
    }
    setBtnLoading(false);
  };

  // const handleSkip = () => {
  //   updateUserAndRoute();
  // };

  return (
    <RootStyle
      title="Fainlearn | Select User"
      isDivRender={false}
      style={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: 'cover'
      }}
    >
      <Box className={classes.wrapper}>
        <Card
          style={{
            position: 'relative',
            padding: '0 15px',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '480px',
            width: '100%'
          }}
        >
          <Box component="img" src="/static/logo-new.svg" sx={{ height: '100px' }} />
          <Box sx={{ padding: '20px' }}>
            <Box className={classes.form}>
              {/* == Form Text == */}
              <Typography variant="h4" sx={{ marginBottom: '5px' }}>
                {displayAdditionalInfo && (
                  <IconButton onClick={() => setIsAdditionalInfo(false)}>
                    <BackArrowIcon />
                  </IconButton>
                )}
                Student Form
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: '30px' }}>
                Complete the form below to get started.
              </Typography>

              <TextField
                style={{ marginBottom: '20px' }}
                label="Full Name"
                placeholder="Eg. John Doe"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                error={fullNameError && !fullName}
                helperText={fullNameError && !fullName ? 'Full Name is required' : ''}
              />
              <Box style={{ marginBottom: '20px' }}>
                <FormLabel>Gender</FormLabel>
                <RadioGroup row value={gender} onChange={(e) => setGender(e.target.value)}>
                  <FormControlLabel value="male" control={<Radio />} label="Male" />
                  <FormControlLabel value="female" control={<Radio />} label="Female" />
                </RadioGroup>
              </Box>
              {/* College selection */}
              <CollegeSelectionBox onChange={(d) => setSelectedCollege(d)} error={collegeErr} />

              <Box sx={{ display: 'flex', marginTop: '30px' }}>
                <Button
                  variant="outlined"
                  className={classes.button}
                  sx={{ marginRight: '30px' }}
                  onClick={handleBack}
                  disabled={isBtnLoading}
                >
                  Back
                </Button>
                <LoadingButton
                  loading={isBtnLoading}
                  variant="contained"
                  className={classes.button}
                  onClick={handleNext}
                >
                  Next
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
    </RootStyle>
  );
}

StudentForm.propTypes = {
  handleBack: PropTypes.func
};
